import { createEndpoint } from '@/shared/models/api';
import { CompanyInformation } from '@/app/api/morgan-thermal/company';

export const getCompany = createEndpoint<CompanyInformation>(({ fetch }) => {
  return (companyId: CompanyInformation['id']) => fetch(`/Company/${companyId}`);
});